// homepage Best Selling Kitchen & Bathroom Products <h3> > <h2>
let firstH3 = document.querySelector('#halo-product-block-template--18596329881901__3da08ce8-c286-4302-872b-ffde3efcd911 h3');
let newH2 = document.createElement('h2');
firstH3 && newH2 && (newH2.innerHTML = firstH3.innerHTML)
firstH3 && newH2 && firstH3.parentNode.replaceChild(newH2, firstH3);



//  Product Enquiry Button

document.addEventListener("DOMContentLoaded", function() {
  console.log("Enquiry script loaded");

  var enquiryBtn = document.getElementById("enquiryNowBtn");
  var modal = document.getElementById("enquiryModal");
  var closeBtn = document.getElementById("closeEnquiryModal");

  // Function to update hidden field
  function setProductName() {
    var productTitleEl = document.querySelector(".productView-title span");
    var productName = productTitleEl ? productTitleEl.innerText.trim() : "";
    var hiddenInput = document.querySelector("input[name='Product_Name']");
    if (hiddenInput) {
      hiddenInput.value = productName;
      console.log("Hidden field updated with:", productName);
    } else {
      console.log("Hidden input not found");
    }
  }

  if (enquiryBtn) {
    enquiryBtn.addEventListener("click", function() {
      console.log("Enquiry button clicked");
      setProductName(); // set when modal opens
      modal.style.display = "block";
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", function() {
      modal.style.display = "none";
    });
  }

  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  };

  // Listen for form submit inside modal
  document.addEventListener("submit", function(e) {
    if (e.target.closest(".cs-form-parent-warp")) {
      console.log("Form submit detected");
      setProductName();
    }
  }, true);
});

